
import React from "react";
import * as MP4Box from "mp4box";

export default class VideoAudioAnalyzer extends React.Component {
    constructor(props) {
        super(props);

        console.log("file to analyze", this.props.file)

        this.state = {
            file: this.props.file,
            status: "idle",
            message: "",
            audioTracks: [],
            progress: 0
        };

        this.cancelAnalysis = false;
    }

    componentDidMount()
    {
        if (this.props.file)
        {
            this.cancelAnalysis = false;

            this.setState({
                file: this.props.files,
                status: "analyzing",
                message: "Analyse des métadonnées...",
                audioTracks: [],
                progress: 0
            }, () => {
                this.analyzeMP4(this.props.file);
            });
        }
    }
    componentWillUnmount() {
        this.cancelAnalysis = true;
    }


    analyzeMP4 = async (file) => {
        const extension = file.name
            .split(".")
            .pop()
            .toLowerCase();

        if (!["mp4", "m4v", "mov"].includes(extension)) {
            this.setState({
                status: "unsupported",
                message:
                    "Format non pris en charge par l'analyse locale. " +
                    "Le fichier pourra être analysé après upload.",
                audioTracks: []
            });
            return;
        }

        const mp4boxfile = MP4Box.createFile();

        const chunkSize = 1024 * 1024; // 1 Mo
        const maxBytes = 128 * 1024 * 1024; // limite de lecture : 128 Mo

        let offset = 0;
        let finished = false;

        const cancelled = () =>
            this.cancelAnalysis;

        try {
            const result = await new Promise((resolve, reject) => {
                const timeout = setTimeout(() => {
                    reject(new Error(
                        "Métadonnées introuvables dans la limite de lecture."
                    ));
                }, 60000);

                const cleanup = () => clearTimeout(timeout);

                mp4boxfile.onError = (error) => {
                    cleanup();
                    reject(new Error(String(error)));
                };

                mp4boxfile.onReady = (info) => {
                    cleanup();

                    const audioTracks = (info.tracks || [])
                        .filter(track => track.audio)
                        .map((track, index) => ({
                            id: track.id,
                            name: track.name || `Piste audio ${index + 1}`,
                            language: track.language || "und",
                            codec: track.codec || "Inconnu",
                            channels:
                                track.audio.channel_count || null,
                            sampleRate:
                                track.audio.sample_rate || null
                        }));

                    resolve(audioTracks);
                };

                const readNext = async () => {
                    if (finished || cancelled()) {
                        cleanup();
                        return;
                    }

                    if (offset >= file.size || offset >= maxBytes) {
                        finished = true;
                        cleanup();
                        reject(new Error(
                            "Analyse incomplète : métadonnées non trouvées."
                        ));
                        return;
                    }

                    try {
                        const start = offset;
                        const end = Math.min(
                            start + chunkSize,
                            file.size,
                            maxBytes
                        );

                        const buffer = await file
                            .slice(start, end)
                            .arrayBuffer();

                        if (cancelled()) {
                            cleanup();
                            return;
                        }

                        buffer.fileStart = start;

                        const nextOffset =
                            mp4boxfile.appendBuffer(buffer);

                        offset = Math.max(end, nextOffset);

                        this.setState({
                            progress: Math.min(
                                100,
                                Math.round(offset / file.size * 100)
                            )
                        });

                        await readNext();
                    } catch (error) {
                        cleanup();
                        reject(error);
                    }
                };

                readNext();
            });

            if (cancelled()) return;

            this.setState({
                status: "success",
                audioTracks: result,
                message: result.length === 0
                    ? "Aucune piste audio détectée."
                    : `${result.length} piste(s) audio détectée(s).`,
                progress: 100
            });

            if (this.props.onAnalysisComplete) {
                this.props.onAnalysisComplete({
                    file,
                    audioTracks: result,
                    audioTrackCount: result.length
                });
            }
        } catch (error) {
            if (cancelled()) return;

            this.setState({
                status: "error",
                message: error.message ||
                    "Impossible d'analyser ce fichier.",
                audioTracks: []
            });
        }
    };

    render() {
        const {
            status,
            message,
            audioTracks,
            progress
        } = this.state;

        return (
            <div style={{
                padding: 12,
                background: "#202027",
                color: "#eeeeF5",
                borderRadius: 8,
                fontSize: 13,
                display: this.props.visible?"visible":"none"
                
            }}>

                {status === "analyzing" && (
                    <p>Analyse en cours : {progress}%</p>
                )}

                {message && (
                    <p role="status">{message}</p>
                )}

                {audioTracks.length > 0 && (
                    <ul>
                        {audioTracks.map(track => (
                            <li key={track.id}>
                                {track.name} — {track.language}
                                {" — "}{track.codec}
                                {track.channels
                                    ? ` — ${track.channels} canal(aux)`
                                    : ""}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        );
    }
}
